var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeftWithDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70017e-05 12.22C-0.000733891 12.3517 0.0244907 12.4821 0.0742553 12.604C0.12402 12.7258 0.197346 12.8366 0.290027 12.93L11.86 24.47L13.27 23.05L2.41003 12.22L13.22 1.47005L11.8 0.0500488L0.290027 11.47C0.192415 11.5682 0.116238 11.6855 0.0663198 11.8146C0.0164011 11.9437 -0.00617233 12.0818 2.70017e-05 12.22Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6702 13.47C10.344 13.47 10.8902 12.9238 10.8902 12.25C10.8902 11.5762 10.344 11.03 9.6702 11.03C8.99641 11.03 8.4502 11.5762 8.4502 12.25C8.4502 12.9238 8.99641 13.47 9.6702 13.47Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftWithDot);
export default __webpack_public_path__ + "static/media/ChevronLeftWithDot.4a3e96ca.svg";
export { ForwardRef as ReactComponent };